import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { Switch, SxProps, Theme } from '@mui/material'
import { FC } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useSelector } from 'react-redux'

interface AntSwitchProps {
  name?: string
  form?: UseFormReturn<any, any>
  width?: number
  height?: number
  sx?: SxProps<Theme>
  disabled?: boolean
  widthThumb?: number
  heightThumb?: number
  borderThumb?: number
  borderTrack?: number
  transform?: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  defaultChecked?: boolean
}

const AntSwitch: FC<AntSwitchProps> = ({
  name,
  form,
  sx,
  width,
  height,
  disabled,
  widthThumb,
  heightThumb,
  borderThumb,
  borderTrack,
  transform,
  checked,
  onChange,
  defaultChecked,
}) => {
  const themeMode = useSelector(selectTheme)

  if (!form || !name)
    return (
      <Switch
        sx={{
          width: width,
          height: height,
          padding: 0,
          display: 'flex',

          '&:active': {
            '& .MuiSwitch-thumb': {
              width: 25,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
              transform: 'translateX(9px)',
            },
          },
          '& .MuiSwitch-switchBase': {
            padding: '2px',
            '&.Mui-checked': {
              transform: `translateX(${transform}px)`,
              color: '#fff',
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: {
                  ...(themeMode === mode_type.dark
                    ? { backgroundColor: '#5bcf86' }
                    : { backgroundColor: '#004744' }),
                },
              },
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: 'background.default',
              pointerEvents: 'none',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
              backgroundColor: '#fff',
              opacity: 0.8,
            },
          },
          '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: widthThumb,
            height: heightThumb,
            borderRadius: borderThumb,
            transition: 'width 200',
            backgroundColor: '#fff',
          },
          '& .MuiSwitch-track': {
            borderRadius: borderTrack,
            opacity: 1,
            backgroundColor: {
              ...(themeMode === mode_type.dark
                ? { backgroundColor: '#cddada' }
                : { backgroundColor: '#cddada' }),
            },
            boxSizing: 'border-box',
          },
          ...sx,
        }}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        defaultChecked={defaultChecked}
      />
    )

  const {
    control,
    // formState: {  },
  } = form
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Switch
            {...field}
            checked={field.value ?? false}
            sx={{
              width: width,
              height: height,
              padding: 0,
              display: 'flex',
              '&:active': {
                '& .MuiSwitch-thumb': {
                  width: 25,
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                  transform: 'translateX(9px)',
                },
              },
              '& .MuiSwitch-switchBase': {
                padding: '2px',
                '&.Mui-checked': {
                  transform: `translateX(${transform}px)`,
                  color: '#fff',
                  '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: {
                      ...(themeMode === mode_type.dark
                        ? { backgroundColor: '#5bcf86' }
                        : { backgroundColor: '#004744' }),
                    },
                  },
                },
              },
              '& .MuiSwitch-thumb': {
                boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
                width: widthThumb,
                height: heightThumb,
                borderRadius: borderThumb,
                transition: 'width 200',
              },
              '& .MuiSwitch-track': {
                borderRadius: borderTrack,
                opacity: 1,
                backgroundColor: {
                  ...(themeMode === mode_type.dark
                    ? { backgroundColor: '#cddada' }
                    : { backgroundColor: '#cddada' }),
                },
                boxSizing: 'border-box',
              },
              ...sx,
            }}
            disabled={disabled}
          />
        )}
      />
    </>
  )
}

export default AntSwitch
